import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import * as Parse from 'parse';
import { CommonService } from 'src/app/service/common.service';
declare const $: any;
//declare function getLiveData(): any;

@Component({
  selector: 'app-twod-live',
  templateUrl: './twod-live.component.html',
  styleUrls: ['./twod-live.component.scss'],

})
export class TwodLiveComponent implements OnInit{
 
  constructor(
    private storage: LocalStorageService,
    public common: CommonService,
    private spinner: NgxSpinnerService,) { 
  }  
  async ngOnInit() {
    
    this.getLiveData();
    const date = await this.common.getDateTime();
    const currentTime = await this.common.convertMyanmarTime(date);
    this.storage.store('localLiveDate',currentTime);
  }

  async getLiveData() {

    (Parse as any).serverURL = 'https://parseapi.back4app.com';
    //thai
    (Parse as any).keyLiveQueryUrl = 'wss://thai2d3d.b4a.io';
    (Parse as any).initialize('dxEhlPEJK3rGaa1viywMIxS31lqCFZMwb0oHQWXJ', 'G4ePnxxZcdObpoF8bZMx2QzvgNlFrpGb8WHrF0Bx');
   
    var client = new (Parse as any).LiveQueryClient({       
        //thai
        applicationId: 'dxEhlPEJK3rGaa1viywMIxS31lqCFZMwb0oHQWXJ',
        serverURL: 'wss://thai2d3d.b4a.io',
        javascriptKey: 'G4ePnxxZcdObpoF8bZMx2QzvgNlFrpGb8WHrF0Bx'
    });  

    // (Parse as any).serverURL = 'https://parseapi.back4app.com';
    // //thai
    // (Parse as any).keyLiveQueryUrl = 'wss://tslive.b4a.io';
    // (Parse as any).initialize('Y9QHN2Zhm1gJTLsbUo00igiph3hsJHsBpV6MOjm4', '1vfbdd4BUSZYr7QJzhiBQ6WmNfX0Ov5sh3Pfys4l');
   
    // var client = new (Parse as any).LiveQueryClient({       
    //     //thai
    //     applicationId: 'Y9QHN2Zhm1gJTLsbUo00igiph3hsJHsBpV6MOjm4',
    //     serverURL: 'wss://tslive.b4a.io',
    //     javascriptKey: '1vfbdd4BUSZYr7QJzhiBQ6WmNfX0Ov5sh3Pfys4l'
    // });  

    client.open();
    var query = new (Parse as any).Query('TwoDLiveResult');
    var datas = await query.get("xNiYjJixOZ");//xNiYjJixOZ //B08ip5GM6E

    // var queryResult2D = new (Parse as any).Query('Result2D');
    // var twodSectionDatas = await queryResult2D.get("xJyLLYFAPX");
    const timeTwoThirty = new Date(); 
     timeTwoThirty.setHours(14);   // 2:30 PM in 24-hour format
     timeTwoThirty.setMinutes(30);
     timeTwoThirty.setSeconds(0);
     timeTwoThirty.setMilliseconds(0);
     const timefourThirty = new Date(); 
     timefourThirty.setHours(16);   // 2:30 PM in 24-hour format
     timefourThirty.setMinutes(30);
     timefourThirty.setSeconds(0);
     timefourThirty.setMilliseconds(0);
    if (datas != '' && datas != null && datas != undefined) {

        document.getElementById('result').innerHTML = datas.get('result');

        var date = new Date(datas.get('lastUpdateDate').toString());
        var dateStr = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
        var timeStr = date.toLocaleTimeString();
        var updatedTime = "Updated: " + dateStr + " " + timeStr;

        var showAnimation = false;
        var lastIndex=null;
        var sectionDatas = datas.get('data');
        // var sectionDatas=[{"section":"10:30 AM","set":"1,614.59","value":"17,980.15","result":"90","isManual":true,"isShowHistory":true,"isDone":true,"from":"09:30:00","to":"10:30:00","toDisplay":"10:30:00","fromDateTime":"2022-10-31T09:30:00","toDateTime":"2022-10-31T10:30:00","toDisplayDateTime":"2022-10-31T10:30:00","switchManual":true},
        //     {"section":"12:01 PM","set":"1,613.53","value":"26,184.62","result":"34","isManual":true,"isShowHistory":true,"isDone":false,"from":"11:00:00","to":"12:01:00","toDisplay":"12:01:00","fromDateTime":"2022-10-31T11:00:00","toDateTime":"2022-10-31T12:01:00","toDisplayDateTime":"2022-10-31T12:01:00","switchManual":true},
        //     {"section":"02:30 PM","set":"1,612.05","value":"31,478.21","result":"58","isManual":true,"isShowHistory":true,"isDone":false,"from":"13:30:00","to":"14:30:00","toDisplay":"14:30:00","fromDateTime":"2022-10-31T13:30:00","toDateTime":"2022-10-31T14:30:00","toDisplayDateTime":"2022-10-31T14:30:00","switchManual":true},
        //     {"section":"04:30 PM","set":"1,608.76","value":"55,914.30","result":"64","isManual":true,"isShowHistory":false,"isDone":false,"from":"15:00:00","to":"16:30:00","toDisplay":"16:30:00","fromDateTime":"2022-10-31T15:00:00","toDateTime":"2022-10-31T16:30:00","toDisplayDateTime":"2022-10-31T16:30:00","switchManual":false}];
       // console.log("LiveData1111>>>>"+JSON.stringify(sectionDatas));
        
        if (sectionDatas != null && sectionDatas != "") {
            document.getElementById('section-container').innerHTML = '<div id="section-container" class="container"> </div>';
            var sectionList = JSON.parse(sectionDatas);
            //console.log("data"+JSON.stringify(sectionList))
            // var sectionList= [{"section":"10:30 AM","set":"1,614.59","value":"17,980.15","result":"90","isManual":true,"isShowHistory":true,"isDone":false,"from":"09:30:00","to":"10:30:00","toDisplay":"10:30:00","fromDateTime":"2022-10-31T09:30:00","toDateTime":"2022-10-31T10:30:00","toDisplayDateTime":"2022-10-31T10:30:00","switchManual":true},
            // {"section":"12:01 PM","set":"1,613.53","value":"26,184.62","result":"34","isManual":true,"isShowHistory":true,"isDone":false,"from":"11:00:00","to":"12:01:00","toDisplay":"12:01:00","fromDateTime":"2022-10-31T11:00:00","toDateTime":"2022-10-31T12:01:00","toDisplayDateTime":"2022-10-31T12:01:00","switchManual":true},
            // {"section":"02:30 PM","set":"1,612.05","value":"31,478.21","result":"58","isManual":true,"isShowHistory":true,"isDone":false,"from":"13:30:00","to":"14:30:00","toDisplay":"14:30:00","fromDateTime":"2022-10-31T13:30:00","toDateTime":"2022-10-31T14:30:00","toDisplayDateTime":"2022-10-31T14:30:00","switchManual":true},
            // {"section":"04:30 PM","set":"1,608.76","value":"55,914.30","result":"64","isManual":true,"isShowHistory":false,"isDone":false,"from":"15:00:00","to":"16:30:00","toDisplay":"16:30:00","fromDateTime":"2022-10-31T15:00:00","toDateTime":"2022-10-31T16:30:00","toDisplayDateTime":"2022-10-31T16:30:00","switchManual":false}];

            for (let i = 0; i < sectionList.length; i++) {
                var item = sectionList[i];
                var from = new Date(item.fromDateTime);
                var to = new Date(item.toDateTime);
                var toDisplayDateTime=new Date(item.toDisplayDateTime);
                var now = await this.common.convertMyanmarTime(new Date());//new Date();
                 
                if ((from.getTime() < now.getTime() && to.getTime() > now.getTime() && !item.isDone)) 
                {   
                    lastIndex = i;                 
                    showAnimation = true;                                                  
                    break;
            
                } 
                else if((toDisplayDateTime.getTime() <= now.getTime()) && (item.switchManual == true && item.isManual == false))
                {
                    lastIndex = i; 
                    showAnimation = true;   
                    break;                              
                
                }  
                else if(now.getTime() > 17 && item.isDone){

                    showAnimation = false; 
                }  
                else {     
                        showAnimation = false;
                     }             
                
            }

          
            if (showAnimation == false) {
                document.getElementById('result').className = 'resultStyle';
            }
            else {
                document.getElementById('result').className = 'resultStyleAnimate';
            }

            this.getModernInternet();        
            
            console.log(showAnimation)
            for(let i=0;i< sectionList.length; i++){
                if((!sectionList[0].isDone) 
                || (sectionList[0].isDone && sectionList[1].isDone && sectionList[2].isDone && sectionList[3].isDone) 
                || (sectionList[i].isDone && !sectionList[i+1].isDone) ){  
                    console.log("Section>>>>>"+sectionList[i].section)                 
                    if(sectionList[0].isDone &&  sectionList[1].isDone 
                        && sectionList[2].isDone && sectionList[3].isDone){
                          
                            var item= sectionList[3];
                        }
                        else{                                                
                            if(showAnimation){
                                if(!sectionList[0].isDone)
                                {
                                    var item=sectionList[0];
                                } 
                                else{
                                    var item=sectionList[i+1];
                                }                               
                            }
                            else{
                                
                                // if((sectionList[i+1].section=='02:30 PM' && !sectionList[i].isDone) ||(sectionList[i+1].section=='04:30 PM'&& !sectionList[i].isDone))
                                // {
                                //     var item=sectionList[i+1];  
                                // }
                                // else{
                                if(now.getTime() >= timeTwoThirty.getTime()&& i==1)
                                {
                                    var item=sectionList[2]; 
                                }
                                else if(now.getTime()>=timefourThirty.getTime() && i==2 )
                                {
                                    var item=sectionList[3]; 
                                }
                                else
                                {
                                var item=sectionList[i]; 
                                } 
                              //  }
                            }
                        }
                        
                   
                        var section = item.section;
                        var set0 = '--';
                        var set1 = '';        
                        if (item.set != "--" && item.set != null && item.set != '') {
                            set0 = item.set.substr(0, item.set.length - 1);
                            set1 = item.set.substr(item.set.length - 1, item.set.length);
                        }
        
                        var val0 = '--';
                        var val1 = '';
                        var val2 = '';
                        var result = '--';
                        if (item.value != "--" && item.value != null && item.value != '') {
                            val0 = item.value.substr(0, item.value.length - 4);
                            val1 = item.value.substr(item.value.length - 4, 1);
                            val2 = item.value.substr(item.value.length - 3, item.value.length);
                        }
                        if(item.isDone == true ){
                            result = item.result;
                        }
                        else{
                            result = "--";        
                        }     

                        //console.log(item)
                        var now = new Date(); 
                        var isShake = (new Date(item.fromDateTime).getTime() < now.getTime() &&
                        new Date(item.toDateTime).getTime() > now.getTime() && (item.section == "12:01 PM" && !item.isManual)) ||
                        (new Date(item.fromDateTime).getTime() < now.getTime() &&
                        new Date(item.toDateTime).getTime() > now.getTime() && (item.section != "12:01 PM" && !item.isDone)) ||
                        (new Date(item.fromDateTime).getTime() == now.getTime() && !item.isDone) ||
                        (new Date(item.toDateTime).getTime() == now.getTime() && (item.section != "12:01 PM" && !item.isDone)) || 
                        (new Date(item.toDateTime).getTime() <= now.getTime() && (item.section == "12:01 PM" && !item.isManual));
                        // ${isShake ? 'annimate' : 'no-annimate'}
                        document.getElementById('section-container').innerHTML = `${document.getElementById('section-container').innerHTML}
                                <div class='row'>                           
                                    <div class='container'>
                                        <div class='row' style='padding-top: 60px;'> 
                                        <div class='col-6'><p style='color: #EDC967; font-size:80px;font-weight: bold;'>Set</p></div>
                                        <div class='col-6 no-annimate'><span class="text-white" style='font-size:80px;font-weight: 600;'>${set0}</span ><span style='color: #fff;font-size:80px; font-weight: 600;'>${set1}</span></div>        
                                        </div>
                                        <div class='row' style='padding-top: 60px;'> 
                                        <div class='col-6'><p style='color: #EDC967; font-size:80px;font-weight: bold;'>Value</p></div>
                                        <div class='col-6 no-annimate'><span class="text-white" style='font-size:80px; font-weight: 600;'>${val0}</span><span style='color:#fff;font-size:80px;font-weight: 600;'>${val1}</span><span class="text-white" style='color: #fff;font-size:80px;font-weight: 600;'>${val2}</span></div>        
                                        </div>                    
                                    </div>                        
                                </div>`;  
                                $('.loader').hide();  
                                break;
                              
        
                }
                
                
            }
         
        }

       
    }

    var subscription = client.subscribe(query);

    subscription.on('open', result => {
         //console.log("OPENED"+JSON.stringify(result));
    });

    subscription.on('update', async result => {
        // console.log("UPDATED" + result);
        var page = document.getElementById('livePage');
        if (page != null) {
            var datas = result;          

            if (datas != '' && datas != null && datas != undefined) {
                document.getElementById('result').innerHTML = datas.get('result');
                var date = new Date(datas.get('lastUpdateDate').toString());
                var dateStr = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
                var timeStr = date.toLocaleTimeString();
                var updatedTime = "Updated: " + dateStr + " " + timeStr;
                var showAnimation = false;
                var lastIndex=null;        
                var sectionDatas = datas.get('data');
                if (sectionDatas != null && sectionDatas != "") {
                    document.getElementById('section-container').innerHTML = '<div id="section-container" class="container"> </div>';
                    var sectionList = JSON.parse(sectionDatas);    
                    console.log('fff'+JSON.stringify(sectionList))              
                    for (let i = 0; i < sectionList.length; i++) {
                        var item = sectionList[i];
                        var from = new Date(item.fromDateTime);
                        var to = new Date(item.toDateTime);
                        var toDisplayDateTime=new Date(item.toDisplayDateTime);
                        var now = await this.common.convertMyanmarTime(new Date());//new Date();                
                        

                        if ((from.getTime() < now.getTime() && to.getTime() > now.getTime() && !item.isDone)) 
                        {   
                            lastIndex = i;                 
                            showAnimation = true;                            
                            break;
                    
                        } 
                        else if((toDisplayDateTime.getTime() <= now.getTime()) && (item.switchManual == true && item.isManual == false))
                        {
                            lastIndex = i; 
                            showAnimation = true;                             
                            break;   
                        }    
                        else{  
                            showAnimation = false;
                        }  
                    }
                    if (showAnimation == false) {
                        document.getElementById('result').className = 'resultStyle';
                    }
                    else {
                        document.getElementById('result').className = 'resultStyleAnimate';
                    }
                 
                   
                    for(let i=0;i< sectionList.length; i++){                       
                        if((!sectionList[0].isDone) || (sectionList[0].isDone && sectionList[1].isDone && sectionList[2].isDone && sectionList[3].isDone) || (sectionList[i].isDone && !sectionList[i+1].isDone) ){                   
                            if(sectionList[0].isDone &&  sectionList[1].isDone 
                                && sectionList[2].isDone && sectionList[3].isDone){                           
                                var item= sectionList[3];
                            }
                            else{                                
                                if(showAnimation){
                                    //console.log('else') 
                                    if(!sectionList[0].isDone)
                                    {
                                        var item=sectionList[0];
                                    } 
                                    else{
                                        var item=sectionList[i+1];
                                    }                               
                                }
                                else{
                                 
                                            if(now.getTime() >= timeTwoThirty.getTime()&& i==1)
                                                {
                                                    var item=sectionList[2]; 
                                                }
                                                else if(now.getTime()>=timefourThirty.getTime() && i==2 )
                                                {
                                                    var item=sectionList[3]; 
                                                }
                                                else
                                                {
                                                var item=sectionList[i]; 
                                                }  
                                        
                                    
                                }
                            }

                           
                                var section = item.section;
                                var set0 = '--';
                                var set1 = '';                
                                if (item.set != "--" && item.set != null && item.set != '') {
                                    set0 = item.set.substr(0, item.set.length - 1);
                                    set1 = item.set.substr(item.set.length - 1, item.set.length);
                                }
                
                                var val0 = '--';
                                var val1 = '';
                                var val2 = '';                               
                                if (item.value != "--" && item.value != null && item.value != '') {
                                    val0 = item.value.substr(0, item.value.length - 4);
                                    val1 = item.value.substr(item.value.length - 4, 1);
                                    val2 = item.value.substr(item.value.length - 3, item.value.length);
                                }
                                if(item.isDone == true ){
                                    result = item.result;
                                }
                                else{
                                    result = "--";
                
                                }                               
                                var now = new Date(); 
                                var isShake;//=true;
                                if(i == lastIndex){
                                isShake= true;
                                }
                                else{
                                    isShake= false;
                                }                                
                                document.getElementById('section-container').innerHTML = `${document.getElementById('section-container').innerHTML}
                                <div class='row'>                           
                                    <div class='container'>
                                        <div class='row' style='padding-top: 60px;'> 
                                        <div class='col-6'><p style='color: #EDC967; font-size:80px;font-weight: bold;'>Set</p></div>
                                        <div class='col-6 no-annimate'><span class="text-white " style='font-size:80px;font-weight: 600;'>${set0}</span ><span style='color: #fff;font-size:80px; font-weight: 600;'>${set1}</span></div>        
                                        </div >
                                        <div class='row' style='padding-top: 60px;'> 
                                        <div class='col-6'><p style='color: #EDC967; font-size:80px;font-weight: bold;'>Value</p></div>
                                        <div class='col-6 no-annimate'><span class="text-white" style='font-size:80px; font-weight: 600;'>${val0}</span><span style='color:#fff;font-size:80px;font-weight: 600;'>${val1}</span><span class="text-white" style='color: #fff;font-size:80px;font-weight: 600;'>${val2}</span></div>        
                                        </div >                    
                                    </div>                        
                                </div>`;  
                                $('.loader').hide();  
                                break;
                        }                         
                    }                  
                }
            }
        }

    });

  }
  async getModernInternet() {

    var modernInternetLink=new (Parse as any).Query('ModernInternet');
    var modernInternetLinkDatas = await modernInternetLink.get("F0QapwSYJl");//F0QapwSYJl //yuQAHDBzeE
    // console.log("result>>"+JSON.stringify(modernInternetLinkDatas));

    var Live2dboss = new (Parse as any).Query('Live2dboss');
    var Live2dbossDatas = await Live2dboss.get("I2CZXHqtbT");//I2CZXHqtbT //AJotixiCSi
   // console.log(Live2dbossDatas.get('link'))
   
    const axios = require('axios').default;
    const response = await axios.get(Live2dbossDatas.get('link'));
    var datas= response.data.data;
    //console.log("result>>"+JSON.stringify(datas))
    var currentTime= this.storage.retrieve('localLiveDate');
    var dateTime = new Date(currentTime);
    let twodSectionDatas;
    if(datas == undefined || datas == null){
        if((dateTime.getHours() == 9  && dateTime.getMinutes() >= 30) || dateTime.getHours() > 9 ){
            twodSectionDatas={'modern_930': modernInternetLinkDatas.get('modern'),'internet_930': modernInternetLinkDatas.get('internet'),
            'modern_200': "",'internet_200':""}
        }
        if( dateTime.getHours() >= 14 ){
            twodSectionDatas={'modern_930': modernInternetLinkDatas.get('modern'),'internet_930': modernInternetLinkDatas.get('internet'),
            'modern_200': modernInternetLinkDatas.get('modern230'),'internet_200': modernInternetLinkDatas.get('internet230')}
        }
        else{
            twodSectionDatas={'modern_930': modernInternetLinkDatas.get('modern'),'internet_930': modernInternetLinkDatas.get('internet'),
            'modern_200': modernInternetLinkDatas.get('modern230'),'internet_200': modernInternetLinkDatas.get('internet230')}
        }
    }    
    else{        
        if(((dateTime.getHours() == 9  && dateTime.getMinutes() >= 30) || dateTime.getHours() > 9) && dateTime.getHours() < 14 ){
            if(datas.internet_930 == null || datas.modern_930 == null){
                datas.internet_930 = modernInternetLinkDatas.get('internet');
                datas.modern_930 = modernInternetLinkDatas.get('modern');                            
                twodSectionDatas= datas;                
            }  
            else{
                twodSectionDatas= datas;
            }                 
        }
        if(dateTime.getHours() >= 14 ){
            if(datas.internet_930 == null || datas.modern_930 == null){
                datas.internet_930 = modernInternetLinkDatas.get('internet');
                datas.modern_930 = modernInternetLinkDatas.get('modern');                
                twodSectionDatas= datas;
            }  
            if(datas.internet_200 == null || datas.modern_200 == null){                
                datas.internet_200 =  modernInternetLinkDatas.get('internet230');
                datas.modern_200 = modernInternetLinkDatas.get('modern230');
                twodSectionDatas= datas;
            }  
            else{
                twodSectionDatas= datas;
            }
        }
       else{
        twodSectionDatas= datas;      
       }
    }
   // console.log("link>>"+JSON.stringify(twodSectionDatas));   
   
   if (twodSectionDatas != '' && twodSectionDatas != null && twodSectionDatas != undefined) {  
    var internet930 = twodSectionDatas.internet_930 == "" || twodSectionDatas.internet_930 == null ? "--" : twodSectionDatas.internet_930;
    var modern930 = twodSectionDatas.modern_930 == "" || twodSectionDatas.modern_930 == null ? "--" : twodSectionDatas.modern_930;
    var internet200 = twodSectionDatas.internet_200 == "" || twodSectionDatas.internet_200 == null ? "--" : twodSectionDatas.internet_200;
    var modern200 = twodSectionDatas.modern_200 == "" || twodSectionDatas.modern_200 == null ? "--" : twodSectionDatas.modern_200;
    var now = new Date(); 
   // console.log(now.getHours());
    if(now.getHours() >= 9 && now.getHours() < 13){
        document.getElementById('modern-container').innerHTML = `${document.getElementById('modern-container').innerHTML}                    
        <div class='row' style='padding-top: 60px;'> 
        <div class='col-6'><p style='color: #EDC967; font-size:80px;font-weight: bold;'>Modern</p></div>
        <div class='col-6'><span class="text-white " style='font-size:80px;font-weight: 600;'>${modern930}</div>        
        </div >
        <div class='row' style='padding-top: 60px;'> 
        <div class='col-6'><p style='color: #EDC967; font-size:80px;font-weight: bold;'>Internet</p></div>
        <div class='col-6 '><span class="text-white" style='font-size:80px;font-weight: 600;'>${internet930}</div>        
        </div >`; 
    }
    if(now.getHours() >= 13 || now.getHours() < 9){
        document.getElementById('modern-container').innerHTML = `${document.getElementById('modern-container').innerHTML}
        <div class='row' style="padding-top: 60px !important;"> 
        <div class='col-6'><p style='color: #EDC967; font-size:80px;font-weight: bold;'>Modern</p></div>
        <div class='col-6'><span class="text-white " style='font-size:80px;font-weight: 600;'>${modern200}</div>        
        </div >
        <div class='row' style="padding-top: 60px !important;"> 
        <div class='col-6'><p style='color: #EDC967; font-size:80px;font-weight: bold;'>Internet</p></div>
        <div class='col-6 '><span class="text-white" style='font-size:80px;font-weight: 600;'>${internet200}</div>        
        </div >`;
    }                                  

} 
    
  }
}
